// Parse the characters.skills JSON blob, e.g.
// {"Mining":{"Level":1,"Label":"Beginner","Exp":100000,"NextLevel":100,"MaxLevel":5}, ...}
export function parseSkills(skillsJson) {
  if (!skillsJson) return null;

  const toSkill = (entry) => ({
    level: entry?.Level || 0,
    label: entry?.Label || 'Beginner',
    exp: entry?.Exp || 0,
    nextLevel: entry?.NextLevel || 0,
    maxLevel: entry?.MaxLevel || 0
  });

  try {
    const data = JSON.parse(skillsJson);
    return {
      mining: toSkill(data.Mining),
      crafting: toSkill(data.Crafting),
      hunting: toSkill(data.Hunting),
      fishing: toSkill(data.Fishing)
    };
  } catch (error) {
    console.error('Error parsing skills:', error);
    return null;
  }
}
